import type { FC } from 'react';
import { useEmployeeCardPin } from '@pflegenavi/frontend/api-nursing-home';
import { CardPinModalView } from './CardPinModalView';

export interface CardPinModalProps {
  cardId: string;
  lastFourDigits: string;
  onClose: () => void;
}

// Mount only while open: the PIN query has gcTime 0, so unmounting drops it.
export const CardPinModal: FC<CardPinModalProps> = ({
  cardId,
  lastFourDigits,
  onClose,
}) => {
  const {
    data: pin,
    isFetching,
    isError,
    refetch,
  } = useEmployeeCardPin(cardId, true);

  return (
    <CardPinModalView
      lastFourDigits={lastFourDigits}
      pin={pin}
      loading={isFetching}
      error={isError}
      onRetry={() => void refetch()}
      onClose={onClose}
    />
  );
};
